
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import { PronosticoAireState } from '@/store/modules/pronostico-aire/types'
import { PronosticoHidricoEstacionState } from '@/store/modules/pronostico-hidrico-estacion/types'
import addDays from 'date-fns/esm/addDays'
import format from 'date-fns/esm/format'
import parse from 'date-fns/esm/parse'
import { GoogleMapMarker, InfoView } from '@/store/modules/google-maps/types'
import { PronosticoHidricoEstacionApi } from '@/domain/entities/Api'
import DesktopFooter from '@/components/DesktopFooter.vue'
import AlertModal from '@/components/AlertModal.vue'
import { getEnvironments } from '@/environments'
const env = getEnvironments()

const MODULE_PRONOSTICO = 'pronosticoAire'
const MODULE_ESTACION = 'pronosticoHidricoEstacion'
const GOOGLE_MAPS_MODULE = 'googleMaps'
const MODULE_ALERTS = 'alerts'

@Component({
  components: {
    DesktopFooter,
    AlertModal
  }
})
export default class PronosticoAire extends Vue {
  @State(MODULE_PRONOSTICO)
  public pronosticoAire!: PronosticoAireState;
  @Action('getPronosticoAire', { namespace: MODULE_PRONOSTICO })
  private getPronosticoAire: any;
  @Action('deletePronosticoAire', { namespace: MODULE_PRONOSTICO })
  private deletePronosticoAire: any;
  @Action('getEstacionResumen', { namespace: MODULE_ESTACION })
  private getEstacionResumen: any;
  @Action('getLinkDescarga', { namespace: MODULE_ESTACION })
  private getLinkDescarga: any;
  @Action('setMarkers', { namespace: GOOGLE_MAPS_MODULE })
  private setMarkers: any;
  @Action('setInfoViewData', { namespace: GOOGLE_MAPS_MODULE })
  private setInfoViewData: any;
  @Action('resetInfoView', { namespace: GOOGLE_MAPS_MODULE })
  private resetInfoView: any;
  @Action('setOpenDefaultMarkerOption', { namespace: GOOGLE_MAPS_MODULE })
  private setOpenDefaultMarkerOption: any;
  @Action('setDefaultMarker', { namespace: GOOGLE_MAPS_MODULE })
  private setDefaultMarker: any;
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any;
  @Getter('infoView', { namespace: GOOGLE_MAPS_MODULE })
  private infoView!: InfoView;
  @Getter('activeMarker', { namespace: GOOGLE_MAPS_MODULE })
  private activeMarker!: GoogleMapMarker;
  @Getter('estacionResumen', { namespace: MODULE_ESTACION })
  private estacionResumen!: PronosticoHidricoEstacionApi[];
  @Getter('linkDescarga', { namespace: MODULE_ESTACION })
  private linkDescarga!: string;
  @Getter('hasLink', { namespace: MODULE_PRONOSTICO })
  private hasLink!: boolean;
  @Getter('alerts', { namespace: MODULE_ALERTS }) alerts!: [];

  @Action('getAlerts', { namespace: MODULE_ALERTS })
  getAlerts!: any;

  formatAire (pronosticoAire: PronosticoAireState) {
    if (pronosticoAire) {
      return pronosticoAire.pronostico.map((pro) => {
        return {
          id: pro.id,
          position: {
            lat: pro.latitud,
            lng: pro.longitud
          },
          color: pro.color,
          icon: '',
          params: pro
        }
      })
    } else {
      return []
    }
  }

  async created () {
    this.getAlerts()
    await this.resetInfoView()
    await this.setOpenDefaultMarkerOption(false)
    await this.setOpenDefaultMarkerOption(true)
    await this.getPronosticoAire()
    this.setDefaultMarker(this.pronosticoAire.estacion_id)
    const markers = this.formatAire(this.pronosticoAire)
    await this.setMarkers(markers)
    const position = {
      lat: env.settings.PRONOSTICO_AIRE.center.lat,
      lng: env.settings.PRONOSTICO_AIRE.center.lng
    }
    const zoom = env.settings.PRONOSTICO_AIRE.zoom
    this.setPosition({ position, zoom })
  }

  async setInfoViewLocalData () {
    const periodo = {
      inicio: format(addDays(Date.now(), -6), 'yyyy-MM-dd'),
      fin: format(Date.now(), 'yyyy-MM-dd')
    }
    await this.getEstacionResumen({
      estacionId: this.infoView.status.selectedMarker,
      periodo
    })
    if (this.hasLink) {
      await this.getLinkDescarga({
        estacionId: this.infoView.status.selectedMarker,
        periodo
      })
    }
    this.setInfoViewData({
      link: this.linkDescarga || '',
      chartOptions: this.estacionResumen.map((serie: PronosticoHidricoEstacionApi) => {
        const series: any[] = []
        if (serie.incertidumbre) {
          serie.incertidumbre.map((dataSeries, id) => {
            series.push({
              type: 'line',
              name: 'Incertidumbre' + id,
              enableMouseTracking: false,
              showInLegend: false,
              color: '#a29b9b',
              lineWidth: 1,
              data: dataSeries.reduce((list, item) => {
                const parsedDate = parse(item.fecha, 'yyyy-MM-dd H:mm:ss', new Date()).toString()
                list.push([Date.parse(parsedDate), item.valor])
                return list
              }, [] as any[])
            })
          })
        }
        series.push(
          {
            type: 'line',
            name: serie.nombre,
            enableMouseTracking: true,
            showInLegend: true,
            color: '#7bb4ec',
            lineWidth: 3,
            data: serie.valor_list.reduce((list, item) => {
              if (typeof item.valor === 'number') {
                const parsedDate = parse(item.fecha, 'yyyy-MM-dd H:mm:ss', new Date()).toString()
                list.push([Date.parse(parsedDate), parseFloat(item.valor)])
              }
              return list
            }, [] as any[])
          }
        )
        if (serie.pronostico_horario !== null) {
          series.push({
            type: 'line',
            name: 'Pronóstico',
            enableMouseTracking: true,
            showInLegend: true,
            color: 'red',
            lineWidth: 3,
            data: serie.pronostico_horario.reduce((list, item) => {
              if (typeof item.valor === 'number') {
                const parsedDate = parse(item.fecha, 'yyyy-MM-dd H:mm:ss', new Date()).toString()
                list.push([Date.parse(parsedDate), parseFloat(item.valor)])
              }
              return list
            }, [] as any[])
          })
        }
        return {
          title: {
            text: serie.nombre,
            style: { fontSize: '12px' }
          },
          series
        }
      })
    })
  }

  @Watch('infoView.status.active')
  async infoViewChanged (active: boolean) {
    if (active) {
      const { pronostico = {}, nombre, position, color } = this.activeMarker.params
      const data = pronostico ? pronostico.infodata || [] : []
      const date = pronostico ? pronostico.fecha : ''

      let subtitle = 'Pronóstico próximos 3 días'
      if (color === 'orange') {
        subtitle = ''
      }
      this.setInfoViewData({
        title: nombre,
        link: '',
        subtitle: subtitle,
        emptyResponse: 'Origen sin datos.',
        data,
        date,
        position
      })
      this.setInfoViewLocalData()
    }
  }

  beforeDestroy () {
    this.setOpenDefaultMarkerOption(false)
    this.deletePronosticoAire()
    this.setMarkers([])
    this.resetInfoView()
  }
}
